const getMarkdownStorageKey = (pathname?: string) => {
  if (globalThis.window === undefined) return ''
  return `markdownEditorContent-${pathname ?? globalThis.location.pathname}`
}
// use for discarding unsaved changes and clearing storage after saving content to db
export const clearMarkdownStorage = (pathname?: string) => {
  if (globalThis.window === undefined) return
  localStorage.removeItem(getMarkdownStorageKey(pathname))
}
